import { render, staticRenderFns } from "./EditorNavMenuGroup.vue?vue&type=template&id=37148462&"
import script from "./EditorNavMenuGroup.vue?vue&type=script&lang=js&"
export * from "./EditorNavMenuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports